import React, { useState, useEffect } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList, SimpleForm, Create,
    Toolbar, SaveButton, TextInput, useInput, useRedirect, useRefresh, Button as RaButton, usePermissions
} from 'react-admin';
import {
    useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem, withStyles, TextField as MuiTextField, Button, Dialog,
    DialogContent, DialogActions, CircularProgress, DialogTitle, Typography, Menu, Checkbox, FormControlLabel, Radio, IconButton
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import config from "./config.json";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { Link } from "react-router-dom";
import queryString from 'query-string';
import RoomIcon from '@material-ui/icons/Room';
import moment from "moment";
import CustomFilter from './components/CustomFilter';
import Skeleton from '@material-ui/lab/Skeleton';
import notify from './components/CustomUseNotify';
import CustomDeleteButton from './CustomDeleteButton';
import RaAutocompleteInput from './components/RaAutocompleteInput';
import { saveTokens } from './utils/saveTokens';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { stringify } from 'query-string';
import RaEditableTextField from './components/RaEditableTextField';
import AddIcon from '@material-ui/icons/Add';
import * as CSV from 'csv-string';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
// import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';  
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider,KeyboardTimePicker,KeyboardDatePicker } from '@material-ui/pickers';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CustomCreateButton from './components/CustomCreateButton';
import PhonelinkEraseIcon from '@material-ui/icons/PhonelinkErase';
import MobileFriendlyIcon from '@material-ui/icons/MobileFriendly';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        width: 350
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        width: 450
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    columnButton: {
        color: customTheme.palette.primary.main,
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        KhtmlUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
        '&:hover': {
            cursor: 'pointer',
        },
        "&:active": {
            opacity: 0.6,
        }
    },
    menuLink: {
        textDecoration: "none",
        color: "#444",
    },
    columnLink: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
});

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

const TERMINAL_COLUMNS = {
    "Parking Name": true,
    "Status": true,
    "Power Status": true,
    "Battery": true,
    "Coordinates": true,
    "Sim": true,
    "App Version": true,
    "Logged In": true,
    "Model": true,
    "WiFi": true,
    "Last Downloaded At": true,
    "Last Uploaded At": true
};

const renderStatus = (record) => {
    if (record && record.timestamp) {
        let currentTime = moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss");
        let end = moment(record.timestamp);
        let duration = moment.duration(end.diff(currentTime));
        let minutes = duration.minutes();
        return minutes >= -3 ? "Online" : `Last Seen at ${record.timestamp}`
    }
    else return "-"
};

export const ParkingTerminalList = (props) => {
    const classes = useStyles()
    const refresh = useRefresh()
    const { permissions } = usePermissions();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();
    const queryParams = queryString.parse(props.location.search);
    const [prevSearch] = useState(queryParams && queryParams.serial_number ? { inputSearch: queryParams.serial_number, type: "Serial Number" } : sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "")

    const [allowTerminalEdit] = useState(sessionStorage.getItem("allow_terminal_edit") === "1");
    const [allowTerminalDeviceChanges] = useState(sessionStorage.getItem("allow_terminal_device_changes") === "1");
    const [allowDeleteTerminal] = useState(sessionStorage.getItem("allow_delete_terminal") === "1");
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [displayColumns, setDisplayColumns] = useState(localStorage.getItem("terminalColumns") ? JSON.parse(localStorage.getItem("terminalColumns")) : TERMINAL_COLUMNS);
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [parkingMenu, setParkingMenu] = useState({});
    const [serialNumberAlreadyMapped, setSerialNumberAlreadyMapped] = useState(null)
    const [selectedDevice, setSelectedDevice] = useState(null)
    const [selectedWalletAccessKeyId, setSelectedWalletAccessKeyId] = useState(null)
    const [walletId, setWalletId] = useState(null)
    const [updating, setUpdating] = useState(false)

    // const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    // const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = currentParking.zones_obj ? JSON.parse(currentParking.zones_obj) : [];


    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Serial Number"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Serial Number");

    let filterTypesInitState = [
        {
            resourcePath: "clientsInfo",
            filterType: "Clients Name",
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "owner_name",
            responseSource: "clientsInfo",
            source: "clientsInfo",
            showFilter: permissions === 'admin'
        },
        {
            filterType: "Display Columns",
            dataList: { "Parking Name": false, "RFID": false },
            listType: "CheckboxStatic",
            caseType: "CheckboxTypeStatic",
            showFilter: true,
            filterFormat: "Checkbox"
        }
    ]

    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};

    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: queryParams.parking ? currentParking.parking_info_id : currentParking.allZones ? currentParking.parking_info_id : undefined };
    const [bulkDialogVisible, setBulkDialogVisible] = useState(false);
    const [parking, setParking] = useState(null);
    const [loading, setLoading] = useState(false);
    const [serialNumbers, setSerialNumbers] = useState(null)
    const [fileName, setFileName] = useState(null)

        const closeBulkDialog = () => {
            setBulkDialogVisible(false);
            setParking(null)
            setSerialNumbers(null)
            setFileName(null)
            setLoading(false)
        };

        const onCsvUpload = event => {
            if (event.target.files && event.target.files[0]) {
                const file = event.target.files[0];
                if (file.name.substr(-4) === ".csv") {
                    try {
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            const csvData = CSV.parse(reader.result);
                            if (csvData.length === 0) {
                                notify("No Data in the file", "warning");
                                return;
                            }
                            if (csvData[0].length !== 1) {
                                notify("Incorrect number of columns in the csv", "warning");
                                return;
                            }
                            const serialNumbers = []
                            const csvFiltered = csvData.slice(1)
                            for (let i in csvFiltered) {
                                const value = csvFiltered[i];
                                serialNumbers.push(value[0])
                            }
                            setSerialNumbers(serialNumbers)
                            setFileName(file.name)
                        }
                        reader.readAsText(file);
                    } catch (err) {
                        notify("Invalid File Format", "warning");    
                    }
                } else {
                    notify("Invalid File Format", "warning");
                }
            }
        };

        const uploadTerminals = () => {

            if (!parking) return notify('Please select the parking', "info");
            if (!serialNumbers) return notify('Please add the file', "info");
            setLoading(true);

            const params = {
                user_id: sessionStorage.getItem("user_id"),
                serial_numbers: serialNumbers,
                access_key_id: parking.id
            };
            fetch(`${config.HOST_NAME}/crm/v3/parkingTerminals/bulkUpload`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
                body: JSON.stringify(params)
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    setLoading(false);
                    if (json.success) {
                        closeBulkDialog();
                        setParking(null);
                        notify('Terminals uploaded successfully', "success");
                        refresh();
                    } else {
                        notify(json.message, "warning");
                    }
                })
                .catch(error => {
                    setLoading(false);
                    notify('Error while uploading terminals', 'warning');
                });
        };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        const result = finalZones.find((val) => val.id === event.target.value)
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name:  result && result.name ? result.name : undefined,
            allZones: event.target.value === "All"
        });
    };

    const openParkingMenu = (event, row) => {
        event.preventDefault();
        setParkingMenu({ mouseX: event.clientX - 2, mouseY: event.clientY - 4, row })
    };

    const closeParkingMenu = () => {
        setParkingMenu({});
    };

    const closeDialog = () => {
        setSerialNumberAlreadyMapped(null);
    };

    const updateAccessKey = () => {

        if (serialNumberAlreadyMapped.transfer_wallet_balance && !selectedDevice && serialNumberAlreadyMapped.wallet_balance > 0) {
            notify('Please select a Device', 'warning');
            return
        }

        setUpdating(true);
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            serial_number: serialNumberAlreadyMapped.serial_number,
            old_serial_number: serialNumberAlreadyMapped.old_serial_number,
            access_key_id: serialNumberAlreadyMapped.access_key_id,
            terminal_id: serialNumberAlreadyMapped.terminal_id,
        };
        if (serialNumberAlreadyMapped.transfer_wallet_balance) {
            params.transfer_wallet_balance = true
            params.selected_wallet_serial_number = selectedDevice
            params.prev_serial_number_wallet_balance = serialNumberAlreadyMapped.wallet_balance
            params.wallet_id = walletId
            params.selected_wallet_access_key_id = selectedWalletAccessKeyId
        }
        fetch(`${config.HOST_NAME}/crm/v3/replaceMappedSerialNumber`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((responseJson) => {
                setUpdating(false);
                if (responseJson.success) {
                    closeDialog();
                    notify(responseJson.message, "success");
                    refresh()
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setUpdating(false);
                notify('Error Updating Parking Terminal', 'warning')
            });
    };

    const renderLocation = (record) => {
        if (record && record.gps) {
            let coordinates = record.gps.split(",")
            return <Typography variant="body2" color="secondary" className={classes.columnLink}>
                <RoomIcon style={{ fontSize: 20, marginRight: 4 }} />
                {`${parseFloat(coordinates[0]).toFixed(6)}, ${parseFloat(coordinates[1]).toFixed(6)}`}
            </Typography>
        }
        return "-"
    };


    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Clients Name") {
                    values = { ...values, client_info_id: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
                if (filterListValue[val].filterType === "Display Columns") {
                    values = { ...values, columns: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const queryParams = queryString.parse(props.location.search);
        if (queryParams && queryParams.clientInfo) {
            let clientInfo = JSON.parse(queryParams.clientInfo)
            setFilterListValue(
                [{ filterType: "Clients Name", value: clientInfo.owner_name, id: clientInfo.client_info_id },
                { filterType: "Display Columns", value: '', id: '' }]
            )
        }
        if (queryParams.parking)
            setCurrentParking(JSON.parse(queryParams.parking));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    React.useEffect(() => {
        const displayColumnsKeys = Object.keys(displayColumns);
        const summaryColumnsKeys = Object.keys(TERMINAL_COLUMNS);
        let isOutdated = false;
        for (let i in summaryColumnsKeys) {
            if (displayColumnsKeys[i] !== summaryColumnsKeys[i])
                isOutdated = true;
        }
        if (isOutdated) {
            const temp = { ...TERMINAL_COLUMNS };
            for (let column in TERMINAL_COLUMNS) {
                if (displayColumns[column] === false)
                    temp[column] = false;
            }
            setDisplayColumns(temp);
            localStorage.setItem("terminalColumns", JSON.stringify(temp));
        } else {
            localStorage.setItem("terminalColumns", JSON.stringify(displayColumns));
        }
    }, [displayColumns]);

    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>
            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} defaultColumns={TERMINAL_COLUMNS} storageKey="terminalColumns" displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
                {permissions === 'admin' &&
                    <RaButton className='customCreateBtnStyle' title='Upload' onClick={() => setBulkDialogVisible(true)}>
                        <AssignmentTurnedInOutlinedIcon />
                    </RaButton>
                }
                {allowTerminalDeviceChanges && <CustomCreateButton label="Create Terminal" basePath={props.basePath} resource={props.resource} />}
            </div>
            <List {...props}
                style={{marginTop: 20}}
                empty={false}
                filter={filter}
                title="Parking Terminals"
                bulkActionButtons={false}
                exporter={false}
                actions={false}
                pagination={<CustomPagination />} >

                {isSmallDevice ?
                    <SimpleList
                        primaryText={record => record.serial_number}
                        secondaryText={record => (<div>
                            {permissions === 'admin' && record.id && <div><span style={{ color: "#5a5a5a" }}>TID: </span>{record.id}</div>}
                            <div><span style={{ color: "#5a5a5a" }}>Device Name: </span>{record.unique_user_id ? record.unique_user_id : "Default"}</div>
                            {displayColumns["Status"] && typeof record["timestamp"] === "string" && record["timestamp"] !== "" && <div>Status: {renderStatus(record)}</div>}
                            {displayColumns["Battery"] && typeof record["battery"] === "string" && record["battery"] !== "" && <div>Battery: {record["battery"]}</div>}
                            {displayColumns["Power Status"] && typeof record["power_status"] === "string" && record["power_status"] !== "" && <div>Power Status: {record["power_status"]}</div>}
                            {permissions === 'admin' && displayColumns["Sim"] && typeof record["sim"] === "string" && record["sim"] !== "" && record["sim"] !== ",null" && <div>Sim: {record["sim"]}</div>}
                            {displayColumns["Wifi"] && typeof record["wifi"] === "string" && record["wifi"] !== "" && <div>Wifi: {record["wifi"]}</div>}
                            {displayColumns["App Version"] && typeof record["app_version"] === "string" && record["app_version"] !== "" && <div>App Version: {record["app_version"]}</div>}
                            {displayColumns["Model"] && typeof record["model"] === "string" && record["model"] !== "" && <div>Battery: {record["model"]}</div>}
                            {displayColumns["Coordinates"] && typeof record["gps"] === "string" && record["gps"] !== "" && <div>Coordinates: {record["gps"]}</div>}
                            {permissions === 'admin' && displayColumns["Logged In"] && <FunctionField source='logged_in' label='Logged In' render={record => record && record.logged_in ? <GetLoggedInParking record={record} /> : "-"} />}
                            {displayColumns["Parking Name"] && <div
                                className={sessionStorage.getItem("hide_parking_section") !== "1" ? classes.columnButton : undefined}
                                onClick={() => { if (sessionStorage.getItem("hide_parking_section") !== "1" && permissions === 'admin') setCurrentParking({ id: record.access_key_id, general_name: record.parking_name, zone_ids: "", zones: "" }) }}
                                onContextMenu={e => { if (sessionStorage.getItem("hide_parking_section") !== "1" && permissions === 'admin') openParkingMenu(e, record) }}
                            >
                                {record["parking_name"]}
                            </div>}

                            {!viewOnly && <div style={{ display: "flex", gap: 10, justifyContent: 'space-between', alignItems: "center" }}>
                                {allowTerminalDeviceChanges && <OperatorLicenseDetailsDialog {...props} label={false} record={record} key={record.serial_number}/>}
                                {allowTerminalEdit && <ReplaceSerialNumberDialog record={record} setSerialNumberAlreadyMapped={setSerialNumberAlreadyMapped} />}
                                {record.show_replace_parking === 1 && <ReplaceParkingDialog record={record} />}
                                {allowDeleteTerminal && <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/getParkingTerminals'} />}
                            </div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid className={!viewOnly && (allowTerminalDeviceChanges || allowTerminalEdit || allowDeleteTerminal) ? 'ParkingTerminalsDataGrid' : ''} component={ScrollableTable}>
                        {permissions === 'admin' && <TextField source="id" label="TID" />}
                        {/* <FunctionField source="unique_user_id" label="Device Name" render={(record) => record && record.unique_user_id ? record.unique_user_id : "Default"} /> */}
                        <RaEditableTextField source="unique_user_id" label="Device Name" />
                        <FunctionField source="serial_number" label="Serial Number" render={record =>
                            record && record.serial_number ? permissions === 'admin' && sessionStorage.getItem('show_operator_devices') === "1" ?
                                <div style={{ display:"flex", justifyContent:'flex-start', alignItems:"center", columnGap: 5 }}>
                                    <Link to={`/operator/devices?${queryString.stringify({ serial_number: record.serial_number })}`} style={{ textDecoration: "none" }}><span style={{ color: "#334d6e", fontWeight: "bold" }}>{record.serial_number}</span></Link>
                                    <IconButton style={{ width: 24, height:24, color: "#aaa" }} onClick={() => {navigator.clipboard.writeText(record.serial_number)}}><ContentCopyIcon style={{ fontSize: 16 }}/></IconButton>
                                </div>
                                : record.serial_number
                                : '-'} />
                        {displayColumns["Parking Name"] && <FunctionField label="Parking Name" render={row => (
                            <div
                                className={sessionStorage.getItem("hide_parking_section") !== "1" ? classes.columnButton : undefined}
                                onClick={() => { if (sessionStorage.getItem("hide_parking_section") !== "1" && permissions === 'admin') setCurrentParking({ id: row.access_key_id, general_name: row.parking_name, zone_ids: "", zones: "" }) }}
                                onContextMenu={e => { if (sessionStorage.getItem("hide_parking_section") !== "1" && permissions === 'admin') openParkingMenu(e, row) }}
                            >
                                {row["parking_name"]}
                            </div>
                        )} />}
                        {displayColumns["Status"] && <FunctionField source="timestamp" label="Status" render={record => {
                            if (record && record.timestamp) {
                                let currentTime = moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss");
                                let end = moment(record.timestamp);
                                let duration = moment.duration(end.diff(currentTime));
                                let minutes = duration.minutes();
                                return minutes >= -3 ? "Online" : `Last Seen at ${record.timestamp}`
                            }
                            else return "-"
                        }} />}
                        {displayColumns["Power Status"] && <FunctionField source="power_status" label="Power Status" render={record => record && record.power_status ? record.power_status : '-'} />}
                        {displayColumns["Coordinates"] && <FunctionField source="gps" label="Coordinates" render={record => record && record.gps ? renderLocation(record) : '-'} />}
                        {displayColumns["Battery"] && <FunctionField source="battery" label="Battery" render={record => record && record.battery ? record.battery : '-'} />}
                        {displayColumns["WiFi"] && <FunctionField source="wifi" label="WiFi" render={record => record && record.wifi ? record.wifi : '-'} />}
                        {permissions === 'admin' && displayColumns["Sim"] && <FunctionField source="sim" label="Sim" render={record => record && record.sim && record.sim !== ",null" ? record.sim : '-'} />}
                        {displayColumns["App Version"] && <FunctionField source="app_version" label="App Version" render={record => record && record.app_version ? record.app_version : '-'} />}
                        {displayColumns["Model"] && <FunctionField source="model" label="Model" render={record => record && record.model ? record.model : '-'} />}
                        {permissions === 'admin' && displayColumns["Logged In"] && <FunctionField source='logged_in' label='Logged In' render={record => record && record.logged_in ? <GetLoggedInParking record={record} /> : "-"} />}
                        {displayColumns["Last Downloaded At"] && <FunctionField source='last_downloaded_at' label="Last Downloaded At" render={record => record ? renderTime(record.last_downloaded_at) : "-"} />}
                        {displayColumns["Last Uploaded At"] && <FunctionField source='last_entry_uploaded_at' label="Last Uploaded At" render={record => record && record.last_entry_uploaded_at && record.last_exit_uploaded_at && record.last_entry_uploaded_at > record.last_exit_uploaded_at ? renderTime(record.last_entry_uploaded_at) : record && record.last_entry_uploaded_at && record.last_exit_uploaded_at && record.last_entry_uploaded_at < record.last_exit_uploaded_at ? renderTime(record.last_exit_uploaded_at) : "-"} />}

                        {!viewOnly && <FunctionField className="ListIconsContainerParkingTerminals" render={record => record &&
                            <div className="ListIcons">
                                {allowTerminalDeviceChanges && <div>
                                    <OperatorLicenseDetailsDialog {...props} label={false} record={record} key={record.serial_number}/>
                                </div>}
                                {allowTerminalEdit && <div>
                                    <ReplaceSerialNumberDialog record={record} setSerialNumberAlreadyMapped={setSerialNumberAlreadyMapped} />
                                </div>}
                                {record.show_replace_parking === 1 && <div><ReplaceParkingDialog record={record} /></div>}
                                {allowDeleteTerminal && <div>
                                    <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/getParkingTerminals'} />
                                </div>
                                }
                            </div>
                        } />}
                    </Datagrid>
                }
            </List>
            <Menu
                anchorReference="anchorPosition"
                anchorPosition={parkingMenu.mouseY !== null && parkingMenu.mouseX !== null ? { top: parkingMenu.mouseY, left: parkingMenu.mouseX } : { top: 0, left: 0 }}
                keepMounted
                open={Boolean(parkingMenu.mouseX)}
                onClose={closeParkingMenu}
            >
                <Link to={`/parkings/${parkingMenu.row ? parkingMenu.row.access_key_id : ""}/show`} className={classes.menuLink}><MenuItem>Summary</MenuItem></Link>
                <Link to={`/parkings/${parkingMenu.row ? parkingMenu.row.access_key_id : ""}`} className={classes.menuLink}><MenuItem>Settings</MenuItem></Link>
            </Menu>

            {
                serialNumberAlreadyMapped &&
                <Dialog open={serialNumberAlreadyMapped != null} onClose={closeDialog}>
                    {serialNumberAlreadyMapped.transfer_wallet_balance ?
                        <DialogContent>
                            <p>This serial number is already mapped with <strong>{serialNumberAlreadyMapped.parking_name}</strong> and also have wallet balance of <strong>₹ {serialNumberAlreadyMapped.wallet_balance}</strong>. Do you want to replace it?</p>
                            {serialNumberAlreadyMapped.wallet_balance > 0 && <SimpleForm {...props} toolbar={false}>
                                <p>Please Select a Device to <strong>Transfer Wallet Balance</strong></p>
                                <RaAutocompleteInput
                                    source="serial_number"
                                    resourceParam="serial_number"
                                    resourcePath="operatorWallets"
                                    filter={{ available: true }}
                                    label=""
                                    getOptionValue={(option) => {
                                        setWalletId(option['id'])
                                        setSelectedWalletAccessKeyId(option['access_key_id'])
                                        return option['serial_number']
                                    }}
                                    getOptionLabel={(option) => `${option['serial_number']}`}
                                    useAccessKeyId={true}
                                    accessKeyIdValue={serialNumberAlreadyMapped.wallet_access_key_id}
                                    onSelect={(value) => setSelectedDevice(value)}
                                    style={{ marginBottom: "20px" }}
                                />
                            </SimpleForm>}
                        </DialogContent>
                        :
                        <DialogContent>{serialNumberAlreadyMapped.message}</DialogContent>
                    }
                    <DialogActions>
                        <Button onClick={closeDialog}>CANCEL</Button>
                        <Button onClick={updateAccessKey} startIcon={updating && <CircularProgress size={25} />}>REPLACE</Button>
                    </DialogActions>
                </Dialog>
            }
            <Dialog fullWidth open={bulkDialogVisible} onClose={closeBulkDialog}>
                <Typography style={{ fontSize: 16, fontWeight: "600", padding: "16px 24px" }}>Bulk Upload Terminals</Typography>
                <DialogContent style={{ display: "grid", gridRowGap: 20 }}>
                    <ParkingSearchSelector
                        value={parking}
                        onChange={setParking}
                        clearable={false}
                        zones={true}
                        size="small"
                    />
                    {!fileName && !serialNumbers &&
                        <div>
                            <RaButton className={`customStyleBtn ${isSmallDevice ? 'customStyleBtnSmallScreen' : ''}`} variant='outlined' label="Add" style={{ alignSelf: "flex-end", position: "relative", width: "100px" }}>
                                <>
                                    <AddIcon />
                                    <input type="file" accept=".csv" onChange={onCsvUpload} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "inherit" }} />
                                </>
                            </RaButton>
                            <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}><InfoOutlinedIcon style={{ fontSize: 16, color: "#888" }} /> <span style={{ fontSize: 10, marginLeft: 10 }}>Make sure file only contain single column and column heading at the top.</span></div>
                        </div>
                    }

                    {fileName && <Typography style={{ fontSize: 14 }}>File Added: <span style={{ fontWeight: '600' }}>{fileName}</span></Typography>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeBulkDialog} disabled={loading}>Cancel</Button>
                    <Button color="primary" onClick={uploadTerminals} disabled={loading}>{loading ? "Uploading..." : "Upload"} {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
};

export const CreateParkingTerminal = (props) => {
    const redirect = useRedirect();
    const refresh = useRefresh()
    const [serialNumberAlreadyMapped, setSerialNumberAlreadyMapped] = useState(null)
    const [selectedDevice, setSelectedDevice] = useState(null)
    const [walletId, setWalletId] = useState(null)
    const [selectedWalletAccessKeyId, setSelectedWalletAccessKeyId] = useState(null)
    const [updating, setUpdating] = useState(false)
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        if (error.data) {
            setSerialNumberAlreadyMapped(error.data)
        } else notify(error.message, "warning")
    }

    const closeDialog = () => {
        setSerialNumberAlreadyMapped(null);
    };

    const updateAccessKey = () => {
        if (serialNumberAlreadyMapped.transfer_wallet_balance && !selectedDevice && serialNumberAlreadyMapped.wallet_balance > 0) {
            notify('Please select a Device', 'warning');
            return
        }

        setUpdating(true);
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            serial_number: serialNumberAlreadyMapped.serial_number,
            access_key_id: serialNumberAlreadyMapped.access_key_id,
            digital_payments_enabled: serialNumberAlreadyMapped.digital_payments_enabled,
            replaceFrom: "CREATE"
        };
        if (serialNumberAlreadyMapped.transfer_wallet_balance) {
            params.transfer_wallet_balance = true
            params.selected_wallet_serial_number = selectedDevice
            params.prev_serial_number_wallet_balance = serialNumberAlreadyMapped.wallet_balance
            params.wallet_id = walletId
            params.selected_wallet_access_key_id = selectedWalletAccessKeyId
        }
        fetch(`${config.HOST_NAME}/crm/v3/replaceMappedSerialNumber`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params),
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((responseJson) => {
                setUpdating(false);
                if (responseJson.success) {
                    closeDialog();
                    notify(responseJson.message, "success");
                    refresh()
                    redirect(props.basePath)
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setUpdating(false);
                notify('Error Updating Parking Terminal', 'warning')
            });
    };
    return (
        <>
            <Create {...props} onFailure={onFailure} onSuccess={onSuccess}>
                <SimpleForm {...props} redirect="list" toolbar={<CustomToolbar />}>
                    <div className="formLabel-bold" style={{ marginTop: 5 }}>Terminal Details</div>
                    <CustomCreateForm />
                </SimpleForm>
            </Create>
            {
                serialNumberAlreadyMapped &&
                <Dialog open={serialNumberAlreadyMapped != null} onClose={closeDialog}>
                    {serialNumberAlreadyMapped.transfer_wallet_balance ?
                        <DialogContent>
                            <p>This serial number is already mapped with <strong>{serialNumberAlreadyMapped.parking_name}</strong> and also have wallet balance of <strong>₹ {serialNumberAlreadyMapped.wallet_balance}</strong>. Do you want to replace it?</p>
                            {serialNumberAlreadyMapped.wallet_balance > 0 && <SimpleForm {...props} toolbar={false}>
                                <p>Please Select a Device to <strong>Transfer Wallet Balance</strong></p>
                                <RaAutocompleteInput
                                    source="serial_number"
                                    resourceParam="serial_number"
                                    resourcePath="operatorWallets"
                                    filter={{ available: true }}
                                    label=""
                                    getOptionValue={(option) => {
                                        setWalletId(option['id'])
                                        setSelectedWalletAccessKeyId(option['access_key_id'])
                                        return option['serial_number']
                                    }}
                                    getOptionLabel={(option) => `${option['serial_number']}`}
                                    useAccessKeyId={true}
                                    accessKeyIdValue={serialNumberAlreadyMapped.wallet_access_key_id}
                                    onSelect={(value) => setSelectedDevice(value)}
                                    style={{ marginBottom: "20px" }}
                                />
                            </SimpleForm>}
                        </DialogContent>
                        :
                        <DialogContent>{serialNumberAlreadyMapped.message}</DialogContent>}
                    <DialogActions>
                        <Button onClick={closeDialog}>CANCEL</Button>
                        <Button onClick={updateAccessKey} startIcon={updating && <CircularProgress size={25} />}>REPLACE</Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
};

const CustomToolbar = withStyles(toolbarStyles)(props => {
    return (
        <Toolbar {...props}>
            <SaveButton style={{ backgroundColor: "#18cc69", marginTop: 13, width: "120px", borderRadius: 5 }} disableElevation />
        </Toolbar>
    )
});

const CustomCreateForm = (props) => {
    const { input: { onChange: set_access_key_id } } = useInput({ ...props, id: "access_key_id", source: "access_key_id" });
    const { input: { value: digitalPaymentsEnabled, onChange: setDigitalPaymentsEnabled } } = useInput({ ...props, id: "digital_payments_enabled", source: "digital_payments_enabled" });
    const { input: { value: separateAccessOperator, onChange: setSeparateAccessOperator } } = useInput({ ...props, id: "separate_access_operator", source: "separate_access_operator" });
    const { input: { value: limitedValidity, onChange: setLimitedValidity } } = useInput({ ...props, id: "limited_validity", source: "limited_validity" });
    const { input: { onChange: setValidTill } } = useInput({ ...props, id: "valid_till", source: "valid_till" });

    const [selectedDate, setSelectedDate] = React.useState(new Date());

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setValidTill(moment(date).utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss"))
    };

    useEffect(() => {
        setDigitalPaymentsEnabled(0)
        setSeparateAccessOperator(0)
        setLimitedValidity(0)
        setValidTill(moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss"))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <>
        <div className="formLabel-regular" style={{ marginTop: 8 }}>Parking Location</div>
        <RaAutocompleteInput
            source="access_key_id"
            resourceParam="name"
            resourcePath="uniqueParkingAccessKeys"
            label="Parking"
            getOptionValue={option => option["id"]}
            getOptionLabel={option => option["name"]}
            style={{ marginTop: 10, marginBottom: 20, maxWidth: 350 }}
            onSelect={set_access_key_id}
        />
        <div className="grid-250" style={{ marginTop: 8 }}>
            <div>
                <div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Serial Number</div>
                <TextInput source="serial_number" label="" variant="outlined" style={{ width: "100%" }} />
            </div>
        </div>
        <div style={{ marginBottom: "50px" }}>
            <Typography>Device Configurations</Typography>
            <FormControlLabel control={<Checkbox checked={digitalPaymentsEnabled === 1 ? true : false} />} label="Digital Payments" onChange={event => setDigitalPaymentsEnabled(event.target.checked === true ? 1 : 0)} />
            <FormControlLabel control={<Checkbox checked={separateAccessOperator === 1 ? true : false} />} label="Separate Access For Operator Users" onChange={event => setSeparateAccessOperator(event.target.checked === true ? 1 : 0)} />

            <div>
                <FormControlLabel control={<Checkbox checked={limitedValidity === 1 ? true : false} />} label="Limited Validity" onChange={event => setLimitedValidity(event.target.checked === true ? 1 : 0)} />

                {limitedValidity === 1 && <MuiPickersUtilsProvider utils={DateFnsUtils}>

                    <div id='expiryOperatorDateTimePicker' style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", columnGap: 20, rowGap: 20, width: 400 }}>
                        <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-dialog"
                            label="Select Date"
                            format="MM/dd/yyyy"
                            inputVariant='outlined'
                            value={selectedDate}
                            onChange={handleDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date'
                            }}
                            InputProps={{
                                disableUnderline: true,
                            }}
                            InputAdornmentProps={{ marginBottom: -20 }}
                        />
                        <KeyboardTimePicker
                            margin="normal"
                            id="time-picker"
                            label="Selecte Time"
                            inputVariant='outlined'
                            value={selectedDate}
                            onChange={handleDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change time'

                            }}
                        />
                    </div>

                </MuiPickersUtilsProvider>}

            </div>
        </div>

    </>

}

const ReplaceSerialNumberDialog = ({ record, setSerialNumberAlreadyMapped }) => {
    const classes = useStyles();
    const refresh = useRefresh()
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [serialNumber, setSerialNumber] = React.useState("")

    const handleClose = () => {
        setOpen(false)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const replaceHandler = () => {
        setLoading(true)

        let params = {
            id: record.id,
            old_serial_number: record.serial_number,
            serial_number: serialNumber,
            access_key_id: record.access_key_id
        }
        fetch(`${config.HOST_NAME}/crm/v3/replaceParkingTerminalSerialNumber`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false)
                if (json.success) {
                    notify("Successfully Replaced Serial Number", "success");
                    setSerialNumber("")
                    refresh()
                }
                else if (json.data?.serial_mapped) {
                    setSerialNumberAlreadyMapped(json.data)
                    setSerialNumber("")
                    handleClose()
                }
                else notify(json.message, "warning");

            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });
    }

    React.useEffect(() => {
        setSerialNumber(record.serial_number)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>
            <Button title='Replace Serial Number' style={{ color: "#18cc69" }} onClick={handleClickOpen}> <SwapHorizIcon style={{ fontSize: "20px" }} /></Button>
            <Dialog
                open={open}
                onClose={handleClose}
                classes={{ paper: classes.dialogPaper }}
                BackdropProps={{
                    classes: {
                        root: classes.backDrop
                    }
                }}
            ><DialogTitle disableTypography>
                    <Typography variant="h6" component="h6">Replace Serial Number</Typography>
                </DialogTitle>
                <DialogContent>
                    <MuiTextField variant='outlined' label="Serial Number" value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} />
                </DialogContent>
                <DialogActions style={{ marginTop: 20 }}>
                    <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        Close
                    </Button>
                    <Button onClick={replaceHandler} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                        Replace   {loading && <CircularProgress size="1rem" sx={{ color: "white", marginLeft: "20px" }} thickness={6}></CircularProgress>}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

const GetLoggedInParking = ({ record }) => {
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [loading, setLoading] = useState(true);
    const [parkingInfo, setParkingInfo] = useState({})

    React.useEffect(() => {

        fetch(`${config.HOST_NAME}/crm/v3/getParkingDetailByAccessKey/${record.logged_in}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    setParkingInfo(json.data)

                } else {
                    notify(json.message, 'warning');
                }
            })
            .catch((error) => {
                setLoading(false);
                notify('Error Fetching Parking Info', 'warning');
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (<div style={{ display: "block" }}>
        {
            !isSmallDevice ?
                <>
                    {loading ?
                        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
                            <Skeleton variant="text" height={15} width={40} style={{ display: "inline-block", transform: "none" }} />
                        </div>
                        :
                        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
                            {parkingInfo.name}
                        </div>
                    }
                </>
                : <>
                    {<div><span>Logged In: </span>{loading ? <Skeleton variant="text" height={8} width={8} style={{ display: "inline-block", transform: "none", borderRadius: 20 }} /> : parkingInfo.name}</div>}
                </>
        }
    </div>
    );
};

const ReplaceParkingDialog = ({ record }) => {
    const classes = useStyles();
    const refresh = useRefresh()
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = React.useState(false)

    const [accessKeyId, setAccessKeyId] = useState("")
    const [options, setOptions] = useState([]);
    const [autovalue, setAutoValue] = React.useState("");
    const [inputValue, setInputValue] = React.useState("");

    const handleClose = () => {
        setOpen(false)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const replaceHandler = () => {
        setLoading(true)

        let params = {
            prev_access_key_id: record.access_key_id,
            access_key_id: accessKeyId,
            terminal_id: record.id,
            serial_number: record.serial_number
        }
        fetch(`${config.HOST_NAME}/crm/v3/replaceTerminalParkings`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false)
                if (json.success) {
                    notify("Successfully Replaced Serial Number", "success");
                    setAccessKeyId("")
                    setOptions([])
                    setAutoValue("")
                    setInputValue("")
                    refresh()
                }
                else {
                    notify(json.message, "warning");
                    setAccessKeyId("")
                    setOptions([])
                    setAutoValue("")
                    setInputValue("")
                }
            })
            .catch((error) => {
                console.log(error)
                notify("Something went wrong", "warning");
                setLoading(false)
            });
    }

    const fetchParkings = () => {
        const token = sessionStorage.getItem('token');
        if (token != null && token !== "") {
            //setLoading(true);
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify({ name: inputValue ? inputValue : undefined, includeSocieties: true, client_info_id: record.client_info_id }),
                sort: JSON.stringify(["id", "ASC"]),
                page: 1,
                perPage: 10
            }
            fetch(`${config.HOST_NAME}/crm/v3/parkings?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    //setLoading(false);
                    if (responseJson.success) {
                        let data = responseJson.data
                        let results = []
                        for (let val in data) {
                            results.push({ id: data[val].id, accessKey: data[val].access_key, name: data[val].name })
                        }
                        setOptions([...results])

                    } else {
                        notify(responseJson.message, 'warning');
                    }
                })
                .catch((e) => {
                    //setLoading(false);
                    notify('Error fetching data', 'warning');
                    console.log(e);
                });
        }
    };
    React.useEffect(() => {
        fetchParkings()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue])

    return (
        <div>
            <Button title='Replace Parking' style={{ color: "#334d6e" }} onClick={handleClickOpen}> <SwapHorizIcon style={{ fontSize: "20px" }} /></Button>
            <Dialog fullWidth
                open={open}
                onClose={handleClose}
                classes={{ paper: classes.dialogPaperBig }}
                BackdropProps={{
                    classes: {
                        root: classes.backDrop
                    }
                }}
            >
                <DialogContent>
                    <p>Please select a Parking to replace with <strong>{record.parking_name}</strong> </p>
                    <Autocomplete
                        value={autovalue}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                setAutoValue(newValue);
                                setAccessKeyId(newValue.id)
                            }
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                        }}
                        options={options}
                        getOptionLabel={option => option.name}
                        style={{ marginBottom: 20 }}
                        renderInput={(params) => <MuiTextField {...params} label="Parking Name" variant="outlined" />}
                    />
                </DialogContent>
                <DialogActions style={{ marginTop: 10, marginBottom: 20, marginRight: 15 }}>
                    <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        Close
                    </Button>
                    <Button onClick={replaceHandler} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                        Replace   {loading && <CircularProgress size="1rem" sx={{ color: "white", marginLeft: "20px" }} thickness={6}></CircularProgress>}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

function OperatorLicenseDetailsDialog(props) {
    const { record } = props;
    const refresh = useRefresh();

    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [reflectOnEachDevices, setReflectOnEachDevices] = React.useState(false);
    const [unlimited, setUnlimited] = React.useState(false);
    const [extendLicense, setExtendLicense] = React.useState(false);
    const [expireLicense, setExpireLicense] = React.useState(false);
    const [selectedDate, setSelectedDate] = React.useState(new Date());
    const [loading, setLoading] = React.useState(false)
    

    let currentTime = moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss");
    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
        setExpireLicense(false)
        setUnlimited(false)
        setExtendLicense(false)
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const updateLicenseHandler = (event) => {

        if (!unlimited && !extendLicense && !expireLicense) return notify("Please select atleast one (*) option.", "warning")

        event.preventDefault();
        setLoading(true);
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            operator_license_id: record.operator_license_id,
            serial_number: record.serial_number,
            access_key_id: record.access_key_id,
            unlimited: unlimited,
            expire_license: expireLicense,
            extend_license: extendLicense,
            changes_in_all: reflectOnEachDevices,
            expiry_date: expireLicense ? currentTime : extendLicense ? moment(selectedDate).utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss") : undefined
        };
        fetch(`${config.HOST_NAME}/crm/v3/expireOperatorLicense`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
            body: JSON.stringify(params),
        })
            .then(response => response.json())
            .then((responseJson) => {
                setLoading(false);
                if (responseJson.success) {
                    refresh();
                    notify(responseJson.message, "success");
                    closeDialog()
                }
                else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setLoading(false);
                notify('Error Deleting Operator Device', 'warning')
            });
    };

    useEffect(() => {
        if (dialogVisible) {
            if (record && !record.expiry_date) setExpireLicense(true)
            if (record && record.expiry_date < currentTime) setUnlimited(true)
            if (record && record.expiry_date > currentTime) setUnlimited(true)
        }
        if (record.ol_serial_number === 'all')setReflectOnEachDevices(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dialogVisible])


    return (
        <>
            {record && record.expiry_date < currentTime ? <Button title='Device License' style={{ color: customTheme.palette.primary.main }} onClick={openDialog} label={false}> <PhonelinkEraseIcon style={{ fontSize: "20px", color:"#de575e"}} /></Button> :
                <Button title='Device License' style={{ color: customTheme.palette.primary.main }} onClick={openDialog} label={false}> <MobileFriendlyIcon style={{ fontSize: "20px" }} /></Button>}
            <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
                <DialogContent style={{ paddingBottom: 20 }}>
                    <p style={{ fontWeight: 'bold', fontSize: 17, lineHeight: '1px' }}>License Status: <span style={{ color: !record.expiry_date ? customTheme.palette.secondary.main : record.expiry_date < currentTime ? customTheme.palette.error.main : record.expiry_date > currentTime ? customTheme.palette.primary.main : '#fff' }}>{!record.expiry_date ? 'Unlimited' : record.expiry_date < currentTime ? 'Expired' : record.expiry_date > currentTime ? 'On Going' : ''} </span></p>
                    {/* Unlimited */}
                    {record && !record.expiry_date &&
                        <>

                            <Typography style={{ marginBottom: 10 }}>This device license holds unlimited validity for now.</Typography>

                            <Typography>Please select <strong>atleast one (*)</strong> following options to update license details.</Typography>

                            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', columnGap: 10 }}>
                                <FormControlLabel value="end" control={<Radio
                                    checked={expireLicense}
                                    onChange={(event) => {
                                        setExpireLicense(event.target.checked)
                                        setExtendLicense(false)
                                    }}
                                    value={expireLicense}
                                />} label="Expire Now *" />

                                <FormControlLabel value="end" control={<Radio
                                    checked={extendLicense}
                                    onChange={(event) => {
                                        setExpireLicense(false)
                                        setExtendLicense(event.target.checked)
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Extend license *" />
                            </div>
                        </>
                    }

                    {/* Expire */}
                    {record && record.expiry_date < currentTime &&
                        <>
                            <Typography style={{ marginBottom: 10 }}>This device license has been expired on <strong>{moment(record.expiry_date).format('MMMM Do YYYY, h:mm:ss a')} </strong>.</Typography>

                            <Typography>Please select <strong>atleast one (*)</strong> following options to update license details.</Typography>

                            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', columnGap: 10 }}>
                                <FormControlLabel value='end' control={<Radio
                                    checked={unlimited}
                                    onChange={(event) => {
                                        setUnlimited(event.target.checked)
                                        setExtendLicense(false)
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Unlimited license *" />
                                <FormControlLabel value='end' control={<Radio
                                    checked={extendLicense}
                                    onChange={(event) => {
                                        setUnlimited(false)
                                        setExtendLicense(event.target.checked)
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Extend license *" />
                            </div>
                        </>
                    }

                    {/* Extend */}
                    {record && record.expiry_date > currentTime &&
                        <>
                            <Typography style={{ marginBottom: 10 }}>This device license will be expired on <strong>{moment(record.expiry_date).format('MMMM Do YYYY, h:mm:ss a')} </strong>.</Typography>

                            <Typography>Please select <strong>atleast one (*)</strong> following options to update license details.</Typography>

                            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', columnGap: 10 }}>
                                <FormControlLabel value='end' control={<Radio
                                    checked={unlimited}
                                    onChange={(event) => {
                                        setUnlimited(event.target.checked)
                                        setExpireLicense(false)
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Unlimited license *" />
                                <FormControlLabel value='end' control={<Radio
                                    checked={expireLicense}
                                    onChange={(event) => {
                                        setUnlimited(false)
                                        setExpireLicense(event.target.checked)
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />}
                                    label="Expire Now *" />
                            </div>
                        </>
                    }

                    {extendLicense && <MuiPickersUtilsProvider utils={DateFnsUtils}>

                        <div id='expiryOperatorDateTimePicker' style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", columnGap: 20, rowGap: 20, width: 400 }}>
                            <KeyboardDatePicker
                                margin="normal"
                                id="date-picker-dialog"
                                label="Select Date"
                                format="MM/dd/yyyy"
                                inputVariant='outlined'
                                value={selectedDate}
                                onChange={handleDateChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                }}  
                                InputAdornmentProps={{ marginBottom: -20 }}
                            />
                            <KeyboardTimePicker
                                margin="normal"
                                id="time-picker"
                                label="Selecte Time"
                                inputVariant='outlined'
                                value={selectedDate}
                                onChange={handleDateChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change time'

                                }}
                            />
                        </div>

                    </MuiPickersUtilsProvider>}

                    <FormControlLabel style={{ marginTop: 20 }} control={<Checkbox
                        checked={reflectOnEachDevices}
                        onChange={(event) => setReflectOnEachDevices(event.target.checked === true ? 1 : 0)}
                        inputProps={{ 'aria-label': 'controlled' }}
                        disabled={record.ol_serial_number === 'all'}

                    />}
                        label="Reflect these changes to all devices under this parking." />

                </DialogContent>


                <DialogActions style={{ paddingBottom: 20, paddingRight: 20 }}>
                    <Button onClick={closeDialog} style={{ backgroundColor: customTheme.palette.neutral.main, color: customTheme.palette.secondary.main, textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px" }}>Cancel</Button>
                    <Button onClick={updateLicenseHandler} style={{ backgroundColor: customTheme.palette.secondary.main, color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }}>Apply {loading && <CircularProgress size={20} />}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
